import { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X } from 'lucide-react';

const Navigation = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();

  const navLinks = [
    { path: '/', label: 'About Us' },
    { path: '/skin-problems', label: 'Indian Skin Problems' },
    { path: '/product', label: 'Product' },
    { path: '/contact', label: 'Contact Us' }
  ];

  const isActive = (path) => location.pathname === path;

  return (
    <nav className="sticky top-0 z-50 bg-white shadow-sm">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center py-4">
          {/* Logo */}
          <Link to="/" className="text-2xl font-bold" style={{ fontFamily: 'Quicksand, sans-serif', color: '#1e3a8a' }}>
            Moonlit
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden md:flex gap-6">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`py-2 px-3 rounded-lg transition-all duration-300 ${
                  isActive(link.path)
                    ? 'font-semibold'
                    : 'hover:bg-gray-50'
                }`}
                style={{
                  color: isActive(link.path) ? 'hsl(345, 60%, 60%)' : 'hsl(30, 20%, 20%)',
                  fontFamily: 'Nunito, sans-serif'
                }}
              >
                {link.label}
              </Link>
            ))}
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            className="md:hidden p-2 rounded-lg hover:bg-gray-50"
            style={{ color: 'hsl(345, 60%, 60%)' }}
          >
            {isMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <div className="md:hidden pb-4">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                onClick={() => setIsMenuOpen(false)}
                className={`block py-4 px-3 rounded-lg transition-all duration-300 ${
                  isActive(link.path)
                    ? 'font-semibold'
                    : 'hover:bg-gray-50'
                }`}
                style={{
                  color: isActive(link.path) ? 'hsl(345, 60%, 60%)' : 'hsl(30, 20%, 20%)',
                  fontFamily: 'Nunito, sans-serif'
                }}
              >
                {link.label}
              </Link>
            ))}
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navigation;
